import gql from 'graphql-tag'

export const GET_DEPARTMENT = gql`
query QueryType($filter: GetCompanyStructuresInput) {
  companyStructures(filter: $filter) {
    isSuccessful
    message
    companyStructures {
      structureId
      companyId
      parentId
      name
      level
      isPosition
      hasRelation
    }
  }
}`

export const DEPARTMENT_MUTATION_CREATE = gql`
mutation MutationType($input: CreateCompanyStructureInput!) {
  createCompanyStructure(input: $input) {
    isSuccessful
    message
    companyStructure {
      structureId
      companyId
      parentId
      name
      level
      isPosition
    }
  }
}`

export const DEPARTMENT_MUTATION_UPDATE = gql`
mutation UpdateCompanyStructure($input: UpdateCompanyStructureInput!) {
  updateCompanyStructure(input: $input) {
    isSuccessful
    message
    companyStructure {
      structureId
      companyId
      parentId
      name
      level
      isPosition
    }
  }
}`

export const DEPARTMENT_MUTATION_DELETE = gql`
mutation DeleteCompanyStructure($input: GetCompanyStructureInput!) {
  deleteCompanyStructure(input: $input) {
    isSuccessful
    message
  }
}`
